import { IFollowUpDonorForList } from '@nkr/models/index';
import { Alert, Button, Modal } from 'react-bootstrap';

interface IProps {
    show: boolean,
    data: IFollowUpDonorForList,
    onConfirm: () => void,
    onCancel: () => void
}

const ConfirmRemove = (props: IProps) => {
    let fullName = props.data != null ? props.data.firstName + ' ' + props.data.lastName : '';

    return (
        <Modal backdrop='static' show={props.show} onHide={props.onCancel}>
            <Modal.Header closeButton>
                <Modal.Title>Permanently Delete Donor <span style={{ color: 'darkgreen', fontWeight: 'bold' }}>{fullName}</span> from Follow-Up?</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Alert bsStyle='danger' style={{ textAlign: 'center', paddingTop: 7.5, paddingBottom: 7.5 }}>WARNING! This cannot be undone</Alert>

                <p>If you are certain you wish to delete the follow-up record and all associated surveys for donor <strong>{fullName}</strong>, please confirm below.</p>
            </Modal.Body>
            <Modal.Footer>
                <Button bsStyle='primary' onClick={props.onConfirm}>Confirmed, Please Remove</Button>
                <Button onClick={props.onCancel}>Cancel</Button>
            </Modal.Footer>
        </Modal>
    )
}

export default ConfirmRemove;